import { render, staticRenderFns } from "./SummaryLabel.vue?vue&type=template&id=45752b2f&"
import script from "./SummaryLabel.vue?vue&type=script&lang=ts&"
export * from "./SummaryLabel.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryLabel.vue?vue&type=style&index=0&id=45752b2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports